import "./DisconnectModal.css";
import classnames from "classnames";
import disconnectIcon from "./assets/disconnectIcon.svg";

import { useAppSelector } from "./store";

function DisconnectModal() {
  const disconnectModalState = useAppSelector((state) => {
    return state.display.disconnectModal;
  });

  let display = disconnectModalState.enabled ? "notHidden" : "hidden";

  return (
    <div className={display}>
      <div className="disconnectContainer">
        <div className="disconnectModal">
          You have disconnected. Please refresh the page.
          <img className="disconnectIcon" src={disconnectIcon} />
        </div>
      </div>
      <div className="overlay" />
    </div>
  );
}

export default DisconnectModal;
